import { styled } from '@openeducation/oe-rn-themes';
import React, { ReactNode } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import { BackButton } from '../back-button/back-button';
import { OEText } from '../oe-text/oe-text';
import RoundPanel from '../round-panel/round-panel';
export interface CenteredPanelProps {
  backgroundColor?: string;
  panelColor?: string;
  header?: string;
  backAction?: () => void;
  footer?: ReactNode;
  style?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
}

export const CenteredPanel: React.FC<CenteredPanelProps> = ({
  panelColor,
  backgroundColor,
  children,
  header,
  backAction,
  footer,
  style,
  contentStyle,
}) => {
  return (
    <Background backgroundColor={backgroundColor} style={style}>
      <Panel backgroundColor={panelColor} style={contentStyle}>
        {header && (
          <Header>
            {backAction && <BackButton onPress={backAction} size={16} />}
            <HeaderTitle>{header}</HeaderTitle>
          </Header>
        )}
        {children}
      </Panel>
      {footer}
    </Background>
  );
};

const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const HeaderTitle = styled(OEText).attrs(({ theme }) => ({
  fontFamily: theme.secondaryFont,
  fontType: 'bold',
}))`
  font-size: 24px;
  text-align: center;
  width: 100%;
`;

type StyledBackgroundType = {
  backgroundColor?: string;
};

const Panel = styled(RoundPanel)<StyledBackgroundType>`
  align-items: center;
  width: 400px;
  padding: 40px;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ?? theme.color.white};
`;

const Background = styled.View<StyledBackgroundType>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ?? theme.color.lightPrimary};
`;

export default CenteredPanel;
